import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ListingCard from 'src/components/elements/listing-card/ListingCard'
import { useGetRelatedPropertiesQuery } from 'src/redux/api'

interface IRelatedListings {
  propertyId: string
}

// "More from this seller" strip under the announcement (roadmap 41 B3): lets
// the visitor jump between a seller's listings without going back to the map.
const RelatedListings: FC<IRelatedListings> = ({ propertyId }) => {
  const { t } = useTranslation()
  const { data: related } = useGetRelatedPropertiesQuery(propertyId, {
    refetchOnMountOrArgChange: true,
  })

  if (!related || related.length === 0) return null

  return (
    <section className="flex flex-col gap-3 min-w-0">
      <h2 className="m-0 text-[1.375rem] font-extrabold leading-7 text-ink">
        {t('announcement.more_from_seller')}
      </h2>
      <div
        data-noswipe
        className="flex gap-4 overflow-x-auto -mx-4 px-4 scroll-px-4 md:mx-0 md:px-0 md:scroll-px-0 pb-2 snap-x"
      >
        {related.map((item) => (
          <ListingCard
            key={item.id}
            id={item.id}
            href={`/announcement/${item.id}`}
            variant="compact"
            className="shrink-0 w-[13.75rem] snap-start"
            images={item.images || []}
            alt={item.addressString || ''}
            price={item.price}
            listingType={item.listingType}
            propertyType={item.propertyType}
            location={item.addressString}
            topLeft={
              item.isPromoted && (
                <span className="px-2 py-0.5 text-xs font-black text-white bg-brand-strong rounded-lg">
                  {t('MapPage.top-badge')}
                </span>
              )
            }
          />
        ))}
      </div>
    </section>
  )
}

export default RelatedListings
